<script setup lang="ts">
//import { RouterLink, RouterView } from 'vue-router'
import HashGlobeView from "@/views/HashGlobeView.vue";
</script>

<template>
  <!--
  <header>
      <nav>
        <RouterLink to="/">Home</RouterLink>
        <RouterLink to="/about">About</RouterLink>
      </nav>
  </header>
  <RouterView />
  -->
  <HashGlobeView />
</template>

<style lang="scss">
@use "@/assets/base.scss";
</style>
